/**
 * en translations for the public onboarding funnel.
 *
 * Anonymous, pre-identity surfaces: self-service sign-up, the payment return
 * page and the invitation landing. No technology names in any string.
 */

const onboarding = {
  signup: {
    title: 'Create your account',
    subtitle: 'Start serving your guests in minutes.',
    steps: {
      plan: 'Plan',
      details: 'Your details',
      request: 'Your request',
    },
    choose_plan: 'Choose a plan',
    choose_plan_help: 'You can change plan later from your panel.',
    per_month: 'per month',
    per_year: 'per year',
    per_days: 'every %{count} days',
    plan_features: {
      static_qr: 'Static QR codes: %{count}',
      dynamic_qr: 'Dynamic QR codes: %{count}',
      staff: 'Staff members: %{count}',
      unlimited: 'unlimited',
    },
    selected: 'Selected',
    select: 'Select',
    details_title: 'Your details',
    details_help:
      'No need to create a password now: we will email you a link to set it and sign in securely.',
    request_help:
      'Leave us your details and we will get in touch to complete your sign-up. No account is created and nothing is charged at this step.',
    sent_title: 'We have received your request',
    sent_body:
      'Thank you for your interest. We will get in touch to complete your sign-up and answer any questions.',
    sent_help: 'There is nothing else you need to do. Nothing has been charged.',
    fields: {
      full_name: 'Full name',
      email: 'Email',
      company_name: 'Company name',
      contact_no: 'Phone (optional)',
      notes: 'Notes (optional)',
      notes_help: 'Tell us anything we should take into account when preparing your account.',
    },
    continue: 'Continue',
    back: 'Back',
    submit: 'Continue to payment',
    submit_request: 'Send request',
    submitting: 'Processing…',
    loading_plans: 'Loading plans…',
    no_plans: 'There are no plans available right now. Please try again later.',
    error_generic: 'We could not complete the sign-up. Please try again.',
    error_plans: 'We could not load the plans. Please try again later.',
    error_request_generic: 'We could not send your request. Please try again.',
    error_too_many:
      'You have sent several requests in a row. Please wait a few minutes before trying again; if you have already written to us, there is no need to send it again.',
    retry: 'Retry',
    have_account: 'Already have an account?',
    sign_in: 'Sign in here',
  },
  payment: {
    confirming_title: 'We are confirming your payment',
    confirming_body: 'Please wait a moment and do not close this page. We are setting up your account.',
    success_title: 'Payment confirmed',
    success_body:
      'Your account is ready. We have emailed you a link to set your password and sign in.',
    timeout_title: 'Your payment is being processed',
    timeout_body:
      'We are finishing setting up your account. You will receive an email to set your password as soon as it is ready.',
    missing_session_title: 'Payment information not found',
    missing_session_body:
      'Please start the sign-up again. If the problem persists, contact us.',
    go_to_sign_in: 'Go to sign in',
    back_to_signup: 'Back to sign-up',
  },
  invite: {
    title: 'You have been invited to join',
    body:
      'We have emailed you a link to set your password. Once set, sign in with the button below.',
    body_existing:
      'Your access is ready. Sign in with the button below using your usual credentials.',
    go_to_sign_in: 'Go to sign in',
  },
};

export default onboarding;
